import React from "react";
import pey_img_old from "../../../New_Web_design/pey_img_old.png";
import pey_img from "../../../New_Web_design/pey_img.png";

export default function Payments() {
  return (
    <div className="container">
      <div
        className="d-flex mt-5"
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p
          className="header mb-0"
          style={{
            fontFamily: "NunitoBlack",

            color: "white",
          }}
        >
          Payments
        </p>
      </div>
      <div
        className="d-flex"
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p
          className="sub-header"
          style={{
            color: "#929498",
            fontFamily: "JosefinSans",
          }}
        >
          WolfWin Safe & Secure
        </p>
      </div>
      <div className="py-4">
        <img src={pey_img} height="100%" width="100%" />
      </div>
    </div>
  );
}
